module.exports = __webpack_public_path__ + "img/device_c1_three.57376529.jpg";